import React from "react";
import { faCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const NewSkillBox: React.FC<{
    name: string;
}> = ({ name }) => {
    return (    
        <div className='border-green rounded-md mr-4 mb-4 bg-white items-center'>
            <div className='flex items-center px-2 py-1'>
                <div className='mr-2 my-1'>
                    <FontAwesomeIcon icon={faCircle} style={{ color: '#0D9488' }}></FontAwesomeIcon>
                </div>
                {name}
            </div>
        </div>
    )
}